/* eslint-disable camelcase */
// OUTER Lib
import { UNSAFE_ErrorResponseImpl, useNavigate, useRouteError } from 'react-router-dom';

// WIDGETS
import { PageTemplate } from '@_widgets/common';

// SHARED
import { useHTMLParse } from '@_shared/hooks';
import { CHARACTER_IMGS } from '@_shared/imgs';
import { Button } from '@_shared/ui/Button';
import { Typography } from '@_shared/ui/Typography';

// LOCAL
import { getStaticError } from './ErrorPage.logic';
import * as S from './ErrorPage.style';

// STATIC
const BOTTOM_BUTTON_HEIGHT = 50;

export function ErrorPage() {
	const navigate = useNavigate();

	const error = useRouteError() as UNSAFE_ErrorResponseImpl;
	const errorState = getStaticError(error.status);

	const parsedTitle = useHTMLParse(errorState.title);
	const parsedMessage = useHTMLParse(errorState.message !== undefined ? errorState.message : '');

	return (
		<PageTemplate
			header={false}
			nav={
				<S.BottomButtonWrapper>
					<Button
						fullWidth
						height={`${BOTTOM_BUTTON_HEIGHT}px`}
						onClick={() => {
							navigate('/');
						}}
					>
						<Typography type="title-large" color="white-primary">
							메인으로 돌아가기
						</Typography>
					</Button>
				</S.BottomButtonWrapper>
			}
		>
			<S.Container>
				<S.ImgWrapper>
					<img src={CHARACTER_IMGS.ANGRY_CHARACTER_IMG} alt="angry character" />
					<S.MessageIconWrapper>{errorState.Icon}</S.MessageIconWrapper>
				</S.ImgWrapper>
				<S.TextContainer>
					<S.Title>{parsedTitle}</S.Title>
					<Typography type="body-large" color="font-tertiary" textAlign="center">
						{parsedMessage}
					</Typography>
				</S.TextContainer>
			</S.Container>
		</PageTemplate>
	);
}
